// Bileli · modules/media/lib — persisted tus tickets (the resume secret #2). One record per assetId; a
// reload rebuilds the tus.Upload from this + the IDB File + tus's own localStorage offset. TTL 24h.

import type { MediaKind } from '../model/media.types';

import { lsRead, lsSubscribe, lsWrite, MEDIA_TTL_MS } from './lsUtil';

const KEY = 'bileli:pending-media-uploads';
const EVENT = 'bileli:pending-media-uploads:changed';

export interface PendingUploadTicket {
  creationUrl: string;
  tusVersion: string;
  libraryId: number;
  videoGuid: string;
  authorizationSignature: string;
  authorizationExpire: number; // unix SECONDS — past this Bunny auth is dead → restart required
  uploadMetadataBase64: string;
}

export interface PendingUploadEntry {
  assetId: string;
  kind: MediaKind;
  contentType: string;
  filename: string;
  ticket: PendingUploadTicket;
  createdAt: number;
}

function isValid(e: PendingUploadEntry | undefined): e is PendingUploadEntry {
  return Boolean(e && e.assetId && e.ticket && e.ticket.creationUrl && e.ticket.videoGuid);
}

export function listPendingUploads(now = Date.now()): PendingUploadEntry[] {
  const all = lsRead<PendingUploadEntry[]>(KEY) ?? [];
  const fresh = all.filter((e) => isValid(e) && now - e.createdAt < MEDIA_TTL_MS);
  if (fresh.length !== all.length) lsWrite(KEY, fresh, EVENT);
  return fresh;
}

export function savePendingUpload(draft: Omit<PendingUploadEntry, 'createdAt'>): void {
  const rest = listPendingUploads().filter((e) => e.assetId !== draft.assetId);
  lsWrite(KEY, [...rest, { ...draft, createdAt: Date.now() }], EVENT);
}

export function clearPendingUploadByAssetId(assetId: string): void {
  lsWrite(KEY, listPendingUploads().filter((e) => e.assetId !== assetId), EVENT);
}

export function hasPendingUpload(assetId: string, now = Date.now()): boolean {
  return listPendingUploads(now).some((e) => e.assetId === assetId);
}

export function subscribePendingUploads(listener: () => void): () => void {
  return lsSubscribe(KEY, EVENT, listener);
}
